import { toastError } from '@/services/toast';
// import { Checkin } from '@/types/checkin';
// import { Establishment } from '@/types/establishment';
import useEstablishmentsStore from '@/store/establishmentsStore';

import { apiServerFormData } from '..';
import { SchemaType } from '@/components/Establishment/info/components/Bankdata/components/ModalCreateData/schema';
import { Promotion } from '@/types/promotions';
import { EstablishmentData } from '@/components/Establishment/info/components/Info/types';
import { getGurupassClient } from '@/services/gurupass-api-client';
import {
	Attribute,
	Establishment,
	Photo,
	Checkin,
	EstablishmentBankData,
	GurupassFile,
	PhotoKind,
	GetEstablishmentById,
	FilterEstablishmentsRequest,
} from '@gurupass/sdk';
import { EstablishmentResponse } from '@/types/establishment';
export interface CreatePhotoActionParams {
	establishmentId: string;
	file: GurupassFile;
	description: string;
	kind: PhotoKind;
	orderIndex?: number;
}

const establishmentStore = useEstablishmentsStore.getState();

export async function createEstablishment(
	establishment: Establishment
): Promise<Establishment> {
	const client = getGurupassClient();

	try {
		const establishmentWithOpeningHours = {
			...establishment,
		};
		const response = await client?.admin
			.establishments()
			.create(establishment as unknown as EstablishmentResponse)
			.run();

		const status: number | undefined =
			(response as any)?.status ?? (response as any)?.statusCode;
		const ok: boolean | undefined = (response as any)?.ok;

		if (
			(typeof ok === 'boolean' && !ok) ||
			(status && status >= 400) ||
			(response as any)?.success === false
		) {
			const msg =
				(response as any)?.data?.message ||
				(response as any)?.error?.message ||
				'Erro ao criar estabelecimento.';
			const err: any = new Error(msg);
			err.status = status ?? 400;
			err.payload = (response as any)?.data || (response as any)?.error;
			throw err;
		}

		return (response as any).data as Establishment;
	} catch (e: any) {
		const status =
			e?.status ?? e?.response?.status ?? e?.response?.data?.status ?? 400;

		const msg =
			e?.message ||
			e?.response?.data?.message ||
			e?.data?.message ||
			'Erro ao criar estabelecimento.';

		const err: any = new Error(msg);
		err.status = status;
		err.payload = e?.response?.data ?? e?.data ?? e;
		throw err;
	}
}

export async function getEstablishmentsService(
	forceRequest = false
): Promise<Establishment[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.establishments().list().run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getFilteredEstablishments(
	params: FilterEstablishmentsRequest
): Promise<Establishment[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.establishments().filter(params).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getEstablishmentById(
	id: string | string[],
	signal?: AbortSignal
): Promise<GetEstablishmentById | null | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.getById(id as string)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
		return null;
	}
}

export async function updateEstablishment(
	id: string | string[],
	establishment: EstablishmentData
): Promise<Establishment | null> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.update(id as string, establishment as any)
			.run();
		return response?.data as Establishment;
	} catch (error: any) {
		toastError(error?.data?.message);
		return null;
	}
}

export async function updateEstablishmentModalities(
	id: string | string[],
	modalities: string[]
): Promise<void> {
	const client = getGurupassClient();
	try {
		await client?.admin
			.establishments()
			.addModality(id as string, modalities)
			.run();
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function updateEstablishmentAttributes(
	id: string | string[],
	attributes: string[]
): Promise<Establishment | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.addAttribute(id as string, attributes)
			.run();
		return response?.data as Establishment;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function createEstablishmentOpeningHours(
	id: string | string[],
	openingHours: { [key: string]: string }[]
): Promise<Establishment | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.createOpeningHours(id as string, openingHours)
			.run();
		return response?.data as Establishment;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function updateEstablishmentOpeningHours(
	id: string | string[],
	openingHours: {
		openingHours: { [key: string]: string | boolean | null }[];
	}
): Promise<Establishment | undefined> {
	const client = getGurupassClient();
	try {
		console.log('aaaaaaaaaaaaaaaaa', openingHours);
		const response = await client?.admin
			.establishments()
			.updateOpeningHours(id as string, openingHours)
			.run();
		return response?.data as Establishment;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function publishEstablishment(
	id: string | string[]
): Promise<Establishment | null> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.publish(id as string)
			.run();
		return response?.data as Establishment;
	} catch (error: any) {
		toastError(error?.data?.message);
		return null;
	}
}

export async function inactiveEstablishmentService(
	id: string | string[],
	reason: string
): Promise<Establishment | null> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.inactive(id as string, { reason })
			.run();
		return response?.data as Establishment;
	} catch (error: any) {
		toastError(error?.data?.message);
		return null;
	}
}

export async function createEstablishmentPhotos(
	photo: CreatePhotoActionParams
): Promise<Photo | undefined | null> {
	const client = getGurupassClient();
	try {
		await client?.admin.photo().create(photo).run();
	} catch (error: any) {
		toastError(error?.data?.message);
		return null;
	}
}

export async function getEstablishmentPhotosById(
	id: string | string[]
): Promise<Photo[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.photo()
			.getByEstablishment(id as string)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function deleteEstablishmentPhotoById(
	id: string | string[]
): Promise<void> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.photo()
			.delete(id as string)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getEstablishmentAttributesService(
	id: string | string[]
): Promise<Attribute[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.getAttributes(id as string)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getEstablishmentCheckinsService(
	id: string | string[]
): Promise<Checkin[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.getCheckins(id as string)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function createBankData(
	bankData: SchemaType,
	id: string | string[]
): Promise<EstablishmentBankData | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.createBankData(id as string, { ...bankData, active: true })
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function updateBankData(
	id: string,
	bankData: SchemaType
): Promise<EstablishmentBankData | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.updateBankData(id, bankData)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function deleteBankData(id: string): Promise<any> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.removeBankData(id)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

type EstablishmentIntegrations = {
	evo: {
		hasIntegration: boolean;
		hasProducts: boolean;
		productsIds: string[];
	};
	angulare: {
		hasIntegration: boolean;
		hasProducts: boolean;
		productsIds: string[];
	};
	acuity: {
		hasIntegration: boolean;
		hasProducts: boolean;
		productsIds: string[];
	};
};

export async function getEstablishmentIntegrations(
	id: string
): Promise<EstablishmentIntegrations | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.getIntegrations(id as string)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function getEstablishmentPromotions(
	id: string
): Promise<Promotion[] | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.getAllPromotions(id as string)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export const setEstablishmentPartner = async (
	id: string,
	isPartner: boolean
) => {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.establishments()
			.setPartnerStatus(id, isPartner)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
};

export async function updateEstablishmentPhoto(
	photoUuid: string,
	description: string,
	kind: string
): Promise<Photo | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.photo()
			.update(photoUuid, { description, kind } as any)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function updateEstablishmentOrderPhoto(
	photoUuid: string,
	orderIndex: number
): Promise<Photo | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin
			.photo()
			.update(photoUuid, { orderIndex } as any)
			.run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}
